<script>
    import Icon from 'svelte-awesome'
    import Required from './Required.svelte'
    import ValidationMessage from './ValidationMessage.svelte'
    import { FormGroup, InputGroup, DropdownToggle, InputGroupButtonDropdown, Input, Label } from 'sveltestrap'
    import { createEventDispatcher } from 'svelte'
    import { spinner } from 'svelte-awesome/icons'
    import { get, set } from 'dot-prop'

    export let context
    export let formKey
    export let index
    export let keypath // The keypath without the formKey or index, e.g. "attributes.videos.3.url"
    export let value
    export let label
    export let placeholder
    export let required
    export let disabled
    export let helptext
    export let uploading
    export let fileUploader // function that deals with http/api calls and returns S3 fragment
    export let maxWidth = 1200
    export let maxHeight = 1200

    // TODO not sure where we get this info, but will need it when we upload to private folder
    // export let schoolId = 'AKTECH'

    const emptyFragment = {
        mimeType: '',
        byteLength: 0,
        key: '',
        bucket: '',
        filename: ''
    }

    let inputElement
    let validationError

    $: formKeypath = index === undefined ? `${formKey}.${keypath}` : `${formKey}.${index}.${keypath}`
    $: isInvalid = get(context, `error.${formKeypath}.level`) === 'error'
    $: displayValue = get(value, 'filename') || get(value, 'metadata.filename')

    const dispatch = createEventDispatcher()

    const triggerFileUpload = () => {
        if (!disabled && inputElement) {
            inputElement.click()
        }
    }

    const removeFile = () => {
        value = ''
        dispatch('change', { formKey, index, keypath, value: emptyFragment, context })
    }

    const upload = async ({ target }) => {
        const file = target && target.files && target.files[0]

        if (file) {
            const reader = new FileReader()
            uploading = true
            reader.onload = async (event) => {
                file.data = event.target.result.split(',')[1]

                validate(event.target.result).then( async () => {
                    const fileFragment = await fileUploader({ file })

                    value = fileFragment
                    dispatch('change', { formKey, index, keypath, value: fileFragment, context })
                    uploading = false

                    set(context, `error.${formKeypath}`, {})
                }).catch(e => {
                    const validationError = 'The image must not have a dimension over 1200px.'

                    context = set(context, `error.${formKeypath}`, {
                        level: 'error',
                        message: validationError
                    })

                    uploading = false
                })
            }

            reader.readAsDataURL(file)
        }
    }

    const validate = (fileReaderImage) => {
        return new Promise((resolve, reject) => {
            const image = new Image();
            image.src = fileReaderImage;
            image.onload = function () {
                if (this.height > maxHeight || this.width > maxWidth) {
                    reject(false);
                }
                resolve(true);
            };
        })
    }
</script>

<style>
    :global(.input-file-append .btn) {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
    }

    .component-form-field-input {
        position: relative;
    }
</style>

<FormGroup>
    <div
        class="component-form-field-input"
        on:focus
        >
        <Label for={formKeypath}>
            {label || ''}
            <Required {required} />
        </Label>
        <InputGroup>
            <Input
                type="text"
                readonly
                id={formKeypath}
                name={formKeypath}
                {placeholder}
                {isInvalid}
                value={displayValue}
                {disabled}
            />
            <InputGroupButtonDropdown
                class="input-file-append"
                addonType="append"
                isOpen={false}
                toggle={() => false}
                on:click={triggerFileUpload}
            >
                {#if disabled}
                    <DropdownToggle disabled style="cursor: not-allowed">
                        Select a file...
                    </DropdownToggle>
                {:else}
                    {#if displayValue}
                        <DropdownToggle on:click={removeFile}>Clear</DropdownToggle>
                    {:else if uploading}
                        <DropdownToggle disabled>
                            <Icon class="appIconSpinner" data={spinner} spin />
                        </DropdownToggle>
                    {:else}
                        <DropdownToggle on:click={triggerFileUpload}>
                            Select a file...
                        </DropdownToggle>
                    {/if}
                {/if}
            </InputGroupButtonDropdown>
        </InputGroup>
    </div>
        <ValidationMessage {context} {formKeypath} {helptext} />

        <input class="invisible" bind:this={inputElement} on:change={upload} type="file" accept=".jpg,.jpeg,.png" />
</FormGroup>
